/**
 * Renovation Kanban Configuration
 *
 * Configuration for the Renovation Projects kanban board using the global Kanban component.
 */

import { KanbanConfig } from "../types";
import { RenovationProject, ProjectStatus } from "shared/types/renovation";
import { renovationPhaseColumns } from "screens/buildings/components/renovationTab/renovationPhaseConfig";

/**
 * Renovation Kanban Configuration
 *
 * This config defines how the Renovation Projects kanban should look and behave:
 * - Uses phase columns from renovationPhaseConfig (single source of truth)
 * - Shows count per column
 * - Non-scrollable columns (full height)
 * - Grid layout automatically adapts to number of columns (5 statuses)
 */
export const renovationKanbanConfig: KanbanConfig<
  RenovationProject,
  ProjectStatus
> = {
  // Column definitions from existing renovationPhaseConfig
  columns: renovationPhaseColumns,

  // Get the status for a renovation project
  getItemStatus: (project: RenovationProject) => project.status,

  // Show count badge per column
  showCount: true,

  // No add button for renovation projects
  showAddButton: false,

  // Empty state configuration
  emptyState: {
    message: "Geen projecten",
  },

  // Columns are not scrollable (they stretch to full height)
  scrollableColumns: false,
};
